import React from "react";

const SkeletonProgramCard: React.FC = () => {
  return (
    <div className="border border-[#CFD4DD] rounded-lg p-4 w-full bg-white shadow-sm flex flex-col justify-between cursor-pointer hover:shadow transition duration-200 ease-in-out animate-pulse">
      <div className="relative">
        {/* Top right: Status pill + menu icon */}
        <div className="absolute top-0 right-0 flex space-x-2 items-center">
          <div className="h-[1.25rem] w-20 bg-gray-200 rounded-full" />
          <div className="w-6 h-6 bg-gray-200 rounded-full" />
        </div>

        {/* Program title */}
        <div className="flex justify-between items-start mb-1">
          <div className="h-4 w-28 bg-gray-200 rounded" />
        </div>

        {/* Description (2 lines) */}
        <div className="h-[0.5rem] w-2/3 bg-gray-200 rounded mb-1" />
        <div className="h-[0.5rem] w-2/3 bg-gray-200 rounded mb-4" />
      </div>

      {/* Budget + Completion */}
      <div className="flex items-start space-x-6">
        {/* Budget section */}
        <div className="text-[0.67rem] 2xl:text-xs text-gray-600 space-y-1">
          <div className="h-3 w-12 bg-gray-200 rounded" />
          <div className="h-4 w-28 bg-gray-200 rounded" />
        </div>

        {/* Completion section */}
        <div className="flex-1 space-y-1">
          <div className="h-3 w-16 bg-gray-200 rounded text-[0.67rem] 2xl:text-xs" />
          <div className="w-full flex items-center space-x-4">
            <div className="relative w-full h-1 bg-gray-200 rounded" />
            <div className="h-4 w-8 bg-gray-200 rounded text-[0.67rem] 2xl:text-xs" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonProgramCard;
